import React, { useState, useEffect, useMemo } from "react";
import {
  extractDateFromStr,
  getLatestDateFromData,
} from "../../../Utils/utils";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import EquityTabComponent from "./EquityTabComponent";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const EquityPage = () => {
  const [activeTab, setActiveTab] = useState("");
  // const [lastUpdated, setLastUpdated] = useState("");
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    data: getEquityTableData = [],
    // energyAssetsError,
    isLoading: getEquityTableIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "equity_category",
    lang: languageType,
  });

  const transformedEquityArray = getEquityTableData.reduce((acc, obj) => {
    const category = obj.field_equity_category;
    const categoryEntry = acc.find((item) => item.title === category);
    if (categoryEntry) {
      categoryEntry.data.push(obj);
    } else {
      acc.push({ title: category, data: [obj] });
    }
    return acc;
  }, []);

  const getLatestNotice = (notices) => {
    return notices.reduce((latest, current) => {
      // If either 'changed' is missing or null, treat it as an old date
      const latestDateMatch = latest?.changed?.match(/datetime="([^"]+)"/);
      const currentDateMatch = current?.changed?.match(/datetime="([^"]+)"/);

      // Convert matched date strings to Date objects, using a very old date as fallback
      const latestDate = latestDateMatch
        ? new Date(latestDateMatch[1])
        : new Date(0);
      const currentDate = currentDateMatch
        ? new Date(currentDateMatch[1])
        : new Date(0);

      // Return the object with the more recent 'changed' date
      return currentDate > latestDate ? current : latest;
    }, notices[0]); // Start with the first item in the array
  };
  useEffect(() => {
    if (transformedEquityArray.length > 0 && !activeTab) {
      const lastElement =
        transformedEquityArray[transformedEquityArray.length - 1];

      setActiveTab(lastElement.title);
      // setLastUpdated(
      //   extractDateFromStr(getLatestNotice(lastElement.data).changed)
      // );
    }
  }, [transformedEquityArray, activeTab]);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(getEquityTableData);
  }, [getEquityTableData]);

  useEffect(() => {
    if (transformedEquityArray.length > 0) {
      const lastElement =
        transformedEquityArray[transformedEquityArray.length - 1];
      setActiveTab(lastElement.title);
      // setLastUpdated(
      //   extractDateFromStr(getLatestNotice(lastElement.data).changed)
      // );
    }
  }, [languageType]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (getEquityTableIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Investors", "निवेशक ")}
        titleLink="/investors/equity"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
              <strong className="">
                {getText(
                  "100% equity belong to NTPC Ltd.",
                  "100% इक्विटी एनटीपीसी लिमिटेड की है"
                )}
              </strong>
            </div>
            <div className="row mt-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-left">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    {transformedEquityArray
                      .slice()
                      .reverse()
                      .map((item, index) => (
                        <li key={index} className="nav-item">
                          <a
                            href="#"
                            className={`nav-link ${
                              activeTab === item.title ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTab(item.title);
                              // setLastUpdated(
                              //   extractDateFromStr(
                              //     getLatestNotice(item.data).changed
                              //   )
                              // );
                            }}
                          >
                            {item.title}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9 print-right">
                {transformedEquityArray?.map(
                  (item, index) =>
                    activeTab === item.title && (
                      <EquityTabComponent
                        key={index}
                        data={item.data}
                        title={item.title}
                      />
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EquityPage;
